import { render, staticRenderFns } from "./ModalDeleteUser.vue?vue&type=template&id=1c471080&scoped=true&"
import script from "./ModalDeleteUser.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c471080",
  null
  
)

export default component.exports